<template>
  <SoAlert class="mb-4">
    <SoSkeleton v-if="isLoading" :type="['list-item-three-line', 'button']" />
    <template v-else>
      <p class="mb-2">
        This customer is paying {{ suggestedAmountMinusPaymentAmount }} amount
        less than what we suggest. Creating a refund without updating the
        payment schedule might create debt in the future. Please update payment
        amount before proceeding.
      </p>
      <p class="mb-2">
        If the customer isn't happy with the suggested amount, you can perform a
        full payment review by clicking the button below. Then please return to
        finish this refund.
      </p>
      <SoButton
        title="Go to review payment flow"
        icon="external-link"
        @click="goToReviewPayment()"
      />
    </template>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { useReviewPaymentStore } from "@/stores/reviewPayment"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import { RouteNames } from "@/types/router"
  import SoAlert from "@/components/SoAlert.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoSkeleton,
      SoButton,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        reviewPayment: useReviewPaymentStore(),
      }
    },
    computed: {
      isLoading() {
        return (
          this.current.suggestedPayment(true, true).isFetching ||
          this.current.nextPaymentSchedule.isFetching ||
          this.current.currentPaymentSchedule.isFetching
        )
      },
      suggestedAmountMinusPaymentAmount() {
        return formatMoney({
          amount:
            this.current.suggestedPayment(true, true).data -
            (this.current.nextPaymentSchedule.data.nextPayment ??
              this.current.currentPaymentSchedule.data?.nextPayment ??
              0),
        })
      },
    },
    methods: {
      goToReviewPayment() {
        this.reviewPayment.reset()
        this.$router.push({ name: RouteNames.CustomerReviewPaymentAmount })
      },
    },
  })
</script>
